(() => {
  const variants_table = document.getElementById('upng-variants-table');
  if(!variants_table) {
    console.error('Variants Table not found!');
    return;
  }

  const is_customer_b2b = variants_table.getAttribute('customer-b2b') === 'true';
  if(!is_customer_b2b) {
    console.error("Customer is not b2b");
    return;
  }
  // Get the rows of all the product variants.
  /**@type {NodeListOf<HTMLTableRowElement>} */
  let variant_rows = variants_table.querySelectorAll('tr[variant-id]');

  /**@type {HTMLButtonElement} */
  const add_to_cart_btn = variants_table.querySelector('#upng-variant-table-add-to-cart-btn');

  // This map has the variantID as the key and the quantity as the value.
  const quantities_map = new Map();

  async function requestCartHtmlAndUpdate() {
    const cart_drawer = document.getElementById('cart-drawer');
    if(cart_drawer){
      cart_drawer.refreshCartDrawer();
    }else{
      try {
        const req = await fetch('/?sections=header');
        if(!req.ok) return false;
        const json = await req.json();
        const header = json.header;
        const parser = new DOMParser();
        const html = parser.parseFromString(header, 'text/html');
        const cart_bubble = html.getElementById('cart-icon-bubble');
        const theme_bubble = document.getElementById('cart-icon-bubble');
        theme_bubble.replaceWith(cart_bubble);
        return true;
      } catch(error) {
        console.error('Could not update the cart HTML ', error);
        return false;
      }
    }
  }

  async function requestUpdateCart() {
    const updates = Object.fromEntries(quantities_map);
    try {
      const req = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });
      if(!req.ok) {
        console.error('Cart could not be updated');
        console.error(req);
        return false;
      }
      return true;
    } catch(error) {
      console.error('Cart could not be updated, ', error);
      return false;
    }
  }

  async function updateCart() {
    // We send the data to Shopify.
    const success = await requestUpdateCart();
    if(!success) {
      console.error('Something went wrong trying to update the cart.');
      return;
    }
    // Now we need to visually update the cart.
    await requestCartHtmlAndUpdate();
  }

  /**
   * 
   * @param {HTMLTableRowElement} row 
   */
  function calculateRowTotals(row) {
    let total = 0;
    // Get the data unit price and get the data box price of the row.
    const unit_price = row.querySelector("[data-unit-price]");
    const box_price = row.querySelector("[data-box-price]");
    // Now get the quantities from their respective inputs.
    const unit_input = row.querySelector(".upng-unit-quantity-cell input");
    const box_input = row.querySelector(".upng-box-quantity-cell input");
    if(unit_price && unit_input) {
      total += parseFloat(unit_price.getAttribute('data-unit-price'))/100 * parseInt(unit_input.value);
    }
    if(box_input && box_price) {
      total += parseFloat(box_price.getAttribute('data-box-price'))/100 * parseInt(box_input.value);
    }
    const row_price_field = row.querySelector(".upng-variant-table-field.total-field.upng-price p b");
    if(row_price_field) {
      row_price_field.textContent = total.toFixed(2).replace('.', ',') + '€';
    }
    calculateTableTotals();
  }
  
  /**
   * Updates the table totals in the footer.
   */
  function calculateTableTotals() {
    const total_units_element = document.getElementById('upng-variant-table-units');
    const total_boxes_element = document.getElementById('upng-variant-table-boxes');
    const subtotal_element = document.getElementById('upng-variant-table-subtotal');
    
    // Get the values from the rows.
    let total_units = 0;
    let total_boxes = 0;
    let subtotal = 0;

    variant_rows.forEach((row) => {
      // We need to get the unit price, and how many units are in the row.
      const unit_price = parseFloat(row.querySelector('[data-unit-price]').getAttribute('data-unit-price'))/100;
      const units_input = row.querySelector('.upng-unit-quantity-cell input');
      let units = 0;
      if(units_input) units = parseInt(units_input.value)
      // If there are boxes, we need to get the quantity of boxes and how many units are in a box.
      const box_units = parseInt(row.querySelector('[data-box-quantity]').getAttribute('data-box-quantity'));
      const box_price = parseFloat(row.querySelector('[data-box-price]').getAttribute('data-box-price'))/100;
      const boxes = row.querySelector('.upng-box-quantity-cell input').value;
      const boxes_variant_id = row.querySelector('[box-variant-id]').getAttribute('box-variant-id');
      total_units += parseInt(units);
      total_boxes += parseInt(boxes);

      subtotal += (unit_price * units) + (box_price * boxes);
    
      // Now we will set the appropiate values on the map, this way we keep the items map in sync.
      const variant_id = row.getAttribute('variant-id');
      if(variant_id) {
        quantities_map.set(parseInt(variant_id), parseInt(units));
      }

      if(boxes_variant_id) {
        quantities_map.set(parseInt(boxes_variant_id), parseInt(boxes));
      }
    });

    console.error('Subtotal '+subtotal);
    // Now we just update the values.
    total_units_element.innerHTML = `<b>${total_units}</b>`;
    total_boxes_element.innerHTML = `<b>${total_boxes}</b>`;
    subtotal_element.innerHTML = `<b>${subtotal.toFixed(2).replace('.', ',')} €</b>`;
  }

  /**
   * This function will hide the boxes columns.
   */
  function hideBoxesColumns() {
    const box_header = variants_table.querySelector('#upng-variants-table-box-price-header');
    const box_input_header = variants_table.querySelector('#upng-variants-table-box-input-header');
    const box_quantity_price_header = variants_table.querySelector('#upng-variants-table-box-unit-price-header');
    const boxes_total_amount = document.getElementById('upng-boxes-total-amount');

    // Hide the headers
    box_header.style.display = 'none';
    box_header.classList.add('upng-variants-table-hidden');
    box_quantity_price_header.style.display = 'none';
    box_input_header.style.display = 'none';
    boxes_total_amount.style.display = 'none';

    // Get the cells that are related to box operations.
    const box_cells = variants_table.querySelectorAll('.upng-box-cell');

    // Hide the cells
    box_cells.forEach((cell) => {
      cell.style.display = 'none';
      cell.classList.add('upng-variants-table-hidden');
    });
  }

  let boxes_exist = false;

  /**
   * Initializes a row.
   * @param {HTMLTableRowElement} row 
   */
  function initRow(row) {
    const variant_id = row.getAttribute('variant-id');
    if (row.getAttribute('unidades-caja') > 0) return;
    console.error(variant_id);
    const sku = row.getAttribute('data-sku');
    const variant_unit_price_element = row.querySelector('[data-unit-price]');
    const variant_box_quantity_element = row.querySelector('[data-box-quantity]');
    const variant_box_price_element = row.querySelector('[data-box-price]');
    //Box discounts
    const variant_box_discount_box= row.querySelector('.box-discount-box');
    const variant_box_old_price = row.querySelector('[box-old-price]');
    const variant_total_element = row.querySelector('.total-field p b');
    const variant_cart_quantity = parseInt(row.getAttribute('cart-quantity'));

    if(!variant_total_element) {
      console.error('A total field element was not found!');
      return;
    }

    if(!variant_unit_price_element) {
      console.error('A unit price element was not found!');
      return;
    }

    // Now we are going to look for a row that has an sku that is the same as this one + "CAJA" at the end of the string.
    const caja_row = variants_table.querySelector(`tr[data-sku="${sku}CAJA"]`);
    let caja_cart_quantity = 0;
    
    // If something was found, we're gonna edit the current row to show the correct box details.
    if(caja_row) {
      console.log(variant_box_discount_box.outerHTML);
      boxes_exist = true;
      // We get the unit price of the caja.
      const caja_unit_price = parseInt(caja_row.querySelector('[data-unit-price]').getAttribute('data-unit-price'));
      // We get the quantity of the caja.
      const caja_quantity = parseInt(caja_row.getAttribute('unidades-caja'));
      // We get the discount quantity of the caja.
      const caja_compare_price = caja_row.querySelector('.upng-variant-table-compare-at-unit-price');
      if(!caja_compare_price.classList.contains('upng-box-price-container')){
        const caja_discount_quantity = parseInt(caja_compare_price.getAttribute('product-discount-quantity'));
        const caja_discount_percentage = parseInt(caja_compare_price.getAttribute('product-discount-percentage'));
        const caja_discount_price = parseInt(caja_compare_price.getAttribute('product-old-price'));
        // And now we set the values on the current row correctly.
        if(!isNaN(caja_discount_quantity)) variant_box_discount_box.setAttribute('box-discount-quantity', caja_discount_quantity);
        if(!isNaN(caja_discount_percentage)) variant_box_discount_box.setAttribute('box-discount-percentage', caja_discount_percentage);
        if(!isNaN(caja_discount_price)) variant_box_discount_box.setAttribute('box-old-price', caja_discount_price);
      }
      caja_cart_quantity = parseInt(caja_row.getAttribute('cart-quantity'));
      // And now we set the values on the current row correctly.
      variant_box_quantity_element.setAttribute('data-box-quantity', caja_quantity);
      variant_box_quantity_element.innerHTML = `<img src="${upng_variants_table_assets.upng_box_icon}"><p>${caja_quantity} uds x ${upng_variants_table_locales.box}</p>`
      // Also set the price.
      variant_box_price_element.setAttribute('data-box-price', caja_unit_price);
      variant_box_price_element.innerHTML = `<p><b>${(caja_unit_price/100).toFixed(2).replace('.', ',')} €</b></p>`
      // And now we update the box-variant-id of the current row.
      row.querySelector('[box-variant-id]').setAttribute('box-variant-id', caja_row.getAttribute('variant-id'));
      // Check if there is an input for the box quantity.
      const variant_box_quantity_input =  caja_row.querySelector('.upng-unit-quantity-cell input');
      // If there isn't we will have to change the box quantity input of the current row to a button.
      if(!variant_box_quantity_input) {
        row.querySelector('.upng-box-quantity-cell .card--product').style.display = 'none';
        row.querySelector('.upng-box-quantity-cell').innerHTML += `<button class="btn btn--secondary upng-variants-table-notify-me-btn" variant-id="${caja_row.getAttribute('variant-id')}">${upng_variants_table_locales.notify_me}</button>`
      }
      // Set the correct unit price for the box.
      row.querySelector('.upng-variant-table-box-unit-price').innerHTML = `${((caja_unit_price/100)/caja_quantity).toFixed(2).replace('.', ',')} €`
      // And finally we snap the caja row out of existence.
      caja_row.remove();
      //caja_row.style.display = 'none';
    } else {
      // If the element does not have a box, we will hide all box related things from the row.
      variant_box_quantity_element.style.display = 'none';
      variant_box_price_element.style.display = 'none';
      const box_price_container = row.querySelector('.upng-box-price-container');
      if(box_price_container) box_price_container.style.display = 'none';
      // And the inputs too.
      row.querySelector('.upng-box-quantity-cell .card--product').style.display = 'none';
    }

    const unit_price = parseInt(variant_unit_price_element.getAttribute('data-unit-price'))/100;
    console.log(unit_price);
    /**@type {HTMLInputElement} */
    const variant_unit_quantity_input = row.querySelector('.upng-unit-quantity-cell input');

    if(variant_unit_quantity_input) variant_unit_quantity_input.value = variant_cart_quantity;

    /**@type {HTMLInputElement} */
    const variant_box_quantity_input = row.querySelector('.upng-box-quantity-cell input');

    variant_box_quantity_input.value = caja_cart_quantity;

    // If there is a unit price element, initialize it.
    if(variant_unit_quantity_input) {
      console.log('cambia cantidad');
      variant_unit_quantity_input.addEventListener('change', (e) => {
        let total = 0;
        // Get the step value, if any.
        const step = variant_unit_quantity_input.getAttribute('step');
        if(step) {
          const numeric_step = parseInt(step);
          // If the new value is not divisible by the step value, round it to the nearest multiple.
          if(variant_unit_quantity_input.value % numeric_step !== 0) {
            variant_unit_quantity_input.value = Math.round(variant_unit_quantity_input.value / numeric_step) * numeric_step;
          }
        }
        // Vamos a intentar obtener los descuentos por tramos.
        const variant_discount_quantity_divs = row.querySelectorAll('[product-discount-quantity]');
        let discount_fail = true;
        if(variant_discount_quantity_divs.length > 0) {
          let last_valid_div;
          for(let i = 0; i < variant_discount_quantity_divs.length; i++) {
            const discount_quantity_div = variant_discount_quantity_divs[i];
            discount_quantity_div.style.display = 'none';
            const discount_min_quantity = discount_quantity_div.getAttribute('product-discount-quantity');
            const discounted_price = discount_quantity_div.getAttribute('product-discounted-price');
            if(discount_min_quantity <= parseInt(variant_unit_quantity_input.value)) {
              total = (parseFloat(discounted_price)/100) * variant_unit_quantity_input.value;
              const unit_price_elem = row.querySelector('[data-unit-price]');
              if(unit_price_elem) {
                unit_price_elem.setAttribute('data-unit-price', discounted_price);
                const unit_price_text = unit_price_elem.querySelector('p b');
                if(unit_price_text) unit_price_text.textContent = (parseFloat(discounted_price)/100).toFixed(2).replace('.', ',') + "€";
              }
              last_valid_div = discount_quantity_div;
              discount_fail = false;
            } else {
              break;
            }
          }
          if(last_valid_div) last_valid_div.style.display = 'flex'; 
        }
        if(discount_fail) {
          const quantity = variant_unit_quantity_input.value;
          const unit_price_elem = row.querySelector('[data-unit-price]');
          if(unit_price_elem) {
            unit_price_elem.setAttribute('data-unit-price', unit_price * 100);
            const unit_price_text = unit_price_elem.querySelector('p b');
            if(unit_price_text) unit_price_text.textContent = unit_price.toFixed(2).replace('.', ',') + "€";
          }
          total = quantity * unit_price;
          // If there are boxes, calculate the price of those.
          if(variant_box_quantity_input && variant_box_price_element) {
            const box_quantity = variant_box_quantity_input.value;
            const box_price = parseInt(variant_box_price_element.getAttribute('data-box-price'))/100;
            total += box_quantity * box_price;
          }
        }
        console.log('Updating totals...');
        // Use 2 decimal places.
        variant_total_element.innerText = total.toFixed(2).replace('.', ',') + '€';
        calculateRowTotals(row);
        calculateTableTotals();
      });
      if (variant_unit_quantity_input.value) {
        variant_unit_quantity_input.dispatchEvent(new Event('change'));
      }
    }

    if(variant_box_quantity_input) {
      const box_price = parseInt(variant_box_price_element.getAttribute('data-box-price'))/100;
      variant_box_quantity_input.addEventListener('change', (e) => {
        let total = 0;
        const discount_box = row.querySelector('.box-discount-box');
        const box_quantity = parseInt(row.querySelector('[data-box-quantity]')?.getAttribute('data-box-quantity'));
        const quantity = variant_box_quantity_input.value;
        const variant_box_discount_quantity_divs = row.querySelectorAll('[box-discount-quantity]');
        let discount_fail = true;
        if(variant_box_discount_quantity_divs.length > 0) {
          let last_discount_data = {
            discount_per: 0,
            discount_old_price: box_price
          }
          for(let i = 0; i < variant_box_discount_quantity_divs.length; i++) {
            const box_discount_quantity_div = variant_box_discount_quantity_divs[i];
            const box_discount_per = parseFloat(box_discount_quantity_div.getAttribute('box-discount-percentage'));
            const box_discount_min_quantity = box_discount_quantity_div.getAttribute('box-discount-quantity');
            if(box_discount_min_quantity <= (quantity * box_quantity)) {
              const discounted_price = box_price - (box_discount_per/100 * box_price);
              total = discounted_price * quantity;
              variant_box_price_element.setAttribute('data-box-price', discounted_price *100)
              const box_price_text = variant_box_price_element.querySelector('p b');
              if(box_price_text) box_price_text.textContent = (parseFloat(discounted_price)).toFixed(2).replace('.', ',') + "€";
              discount_fail = false;
              last_discount_data.discount_per = box_discount_per;
            }
          }
          if(last_discount_data.discount_per > 0) {
            if(discount_box) {
              discount_box.innerHTML = `
              <p style="text-decoration: line-through;" class="box-old-price">${last_discount_data.discount_old_price}€</p>
              <span class="upng-variant-table-compare-at-discount box-discount-per">-${last_discount_data.discount_per}%</span>`;
              discount_box.style.display = 'flex';
            }
          }
        }
        if(discount_fail) {
          variant_box_price_element.setAttribute('data-box-price', box_price);
          const box_price_text = variant_box_price_element.querySelector('p b');
          if(box_price_text) box_price_text.textContent = box_price.toFixed(2).replace('.', ',') + "€";
          
          if(discount_box) discount_box.style.display = 'none';
          // If there are boxes, calculate the price of those.
          if(variant_unit_quantity_input && variant_box_price_element && variant_box_quantity_element) {
            total += quantity * box_price;
          }
          const units = variant_unit_quantity_input.value;
          total += units * unit_price;
        }
        // Use 2 decimal places.
        variant_total_element.innerText = total.toFixed(2).replace('.', ',') + '€';
        calculateRowTotals(row);
        calculateTableTotals();
      });
      if (variant_box_quantity_input.value) {
        variant_box_quantity_input.dispatchEvent(new Event('change'));
      }
    }
    calculateRowTotals(row);
    calculateTableTotals();

  }

  console.log('variant_rows');
  variant_rows.forEach((row) => initRow(row));
  variant_rows = variants_table.querySelectorAll('tr[variant-id]');

  if(!boxes_exist) hideBoxesColumns();

  /*const quick_add_footer = document.querySelector('quick-add-drawer[open] .quick-add__footer');
  if(quick_add_footer) quick_add_footer.style.display = 'none';*/

  add_to_cart_btn.addEventListener('click', () => {
    const loader = add_to_cart_btn.querySelector('.upng-tabla-variantes-loader');
    if(loader) loader.style.display = 'inline-block';
    add_to_cart_btn.disabled = true;
    updateCart().then(() => {
      if(loader) loader.style.display = 'none';
      add_to_cart_btn.disabled = false;
      // Close the modal.
      const modal = document.querySelector('quick-add-drawer[open]');
      if(modal) modal.close();
    });
  });
})();